import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SalienteLibrarySharedModule } from '@saliente/library';

import { PartnerEditFormComponent } from './partner-edit-form.component';
const COMPONENTS = [PartnerEditFormComponent,];

@NgModule({
	imports: [
		CommonModule, FormsModule, RouterModule, SalienteLibrarySharedModule,
	],
	declarations: [
		...COMPONENTS
	],
	exports: [
		...COMPONENTS
	]
})
export class CommonPartnersSharedModule {
}